<puro-modal
  class="service-guarantees-dialog__modal"
  [className]="'service-guarantees-dialog__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="large"
  [showCloseButton]="true"
  [closeOnBackdrop]="true"
  [actions]="closeActions()"
  (closeModal)="onClose()"
>
  <div class="service-guarantees-dialog" data-testid="service-guarantees-dialog">
    <ul class="service-guarantees-dialog__list">
      @for (key of bulletKeys; track key) {
        <li class="service-guarantees-dialog__item">
          <puro-typography component="p" variant="body1">
            {{ key | translate }}
          </puro-typography>
        </li>
      }
    </ul>

    <puro-typography component="p" variant="body1" class="service-guarantees-dialog__refer">
      {{ 'createShipment.serviceStep.deliveryService.guaranteesModal.referBefore' | translate
      }}<a
        class="service-guarantees-dialog__terms-link"
        data-testid="service-guarantees-terms-link"
        [href]="termsHref()"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'createShipment.serviceStep.deliveryService.guaranteesModal.termsLink' | translate }}</a
      >{{ 'createShipment.serviceStep.deliveryService.guaranteesModal.referAfter' | translate }}
    </puro-typography>
  </div>
</puro-modal>
